module.exports = __webpack_public_path__ + "static/media/Sales icon.5335df22.svg";